import { Component, Input } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { CategoryData } from '../../../../models/category-data.model';

export class CardData {
  constructor(
    public title: string = '',
    public totalCount: number = 0,
    public categories: CategoryData[] = []
  ) {}
}


@Component({
  selector: 'lib-donut-card',
  standalone: false,
  templateUrl: './donut-card.component.html',
  styleUrl: './donut-card.component.scss',
})
export class DonutCardComponent {
  @Input() data!: CardData;

  @Input() categories: CategoryData[] = [];

  donutOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false,
    animation: {
      duration: 0,
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      datalabels: {
        display: false,
      },
    },
    cutout: '55%',
  };

  getDonutData(categories: CategoryData[]) {
    const total = categories.reduce((sum, cat) => sum + cat.count, 0);

    if (total === 0) {
      return {
        labels: ['No Data'],
        datasets: [
          {
            data: [1],
            backgroundColor: ['#f2f3f5'],
            borderWidth: 0,
            cutout: '55%',
            circumference: 360,
            rotation: -90,
          },
        ],
      };
    }

    const data = categories.map((cat) => cat.count);
    const backgroundColor = categories.map((cat) => cat.color);

    return {
      labels: categories.map((cat) => cat.name),
      datasets: [
        {
          data: [1],
          backgroundColor: ['#f2f3f5'],
          hoverBackgroundColor: ['#f2f3f5'],
          borderWidth: 0,
          cutout: '55%',
          circumference: 360,
          rotation: -90,
          weight: 0.3,
        },
        {
          data,
          backgroundColor,
          borderWidth: 0,
        },
      ],
    };
  }
}
